import { useMemo } from 'react';
import useConfig from './useConfig';

const imageSrcBuilder = (host = 'images.gasbuddy.io') => ({ height, url, width } = {}) => url && `https://${host}/${width || 'auto'}x${height || 'auto'}/${url}`;

export default function useImageSrcBuilder() {
  const { imagesHost } = useConfig();
  return useMemo(() => imageSrcBuilder(imagesHost), [imagesHost]);
}
